// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2eubE","calendarButtons":"ClockData_calendarButtons__ORacB"};